import { useState, useEffect } from "react";
import { fetchAllPostPromisedData, fetchAllPromisedData } from "../../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../common/constant";
import { failureToast } from "../../../common/utils/methods/toasterFunctions/function";

export const useGetStudentDetails = ({ psid, studentName }) => {
    const [studentDetails, setStudentDetails] = useState({
        loading: false,
        details: {}
    });

    const fetchStudentDetails = async () => {
        try {
            setStudentDetails(prev => ({ ...prev, loading: true }))

            const resp = await Promise.all([
                fetchAllPostPromisedData(`${endpoint.student.getInfo}?mask=true`, [{ commonInfoEnums: "STUDENT_DETAILS", params: [psid] }]),
                fetchAllPromisedData(`${endpoint?.studentDetails?.getStudentAddressByPsid}/${psid}`),
            ]);

            const studentPersonalInfo = resp[0]?.data?.studentDetailsDTO?.[0];
            const addressDetails = resp[1];

            if (!studentPersonalInfo) {
                failureToast("Student Details not found!");
                throw new Error("Student Details not found!")
            }
            if (!addressDetails) {
                failureToast("Address details not found!");
                throw new Error("Address details not found!")
            }

            const { studentFirstName, studentLastName, studentFatherName, primaryMobileNumber, studentEmailId } = studentPersonalInfo ?? {};
            const { addressLine1 = '-', addressLine2 = '-', city, state, postalCode } = addressDetails ?? {};

            // if (!resp[1]) failureToast("Address details not found!");

            setStudentDetails(prev => ({
                ...prev,
                details: {
                    studentName: `${studentFirstName} ${studentLastName}`,
                    psid,
                    studentFatherName,
                    studentMobileNumber: primaryMobileNumber,
                    studentEmailId,
                    address: `${addressLine1}, ${addressLine2}`,
                    city,
                    state,
                    pincode : postalCode
                }
            }))
        } catch (err) {
            console.error(err);
        } finally {
            setStudentDetails(prev => ({ ...prev, loading: false }))
        }
    }

    useEffect(() => {
        fetchStudentDetails();
    }, [])

    return studentDetails;
}